import http from "@/services/http";
import {COMPETENT_AUTHORITIES, RECOMMENDATION_URL} from "@/services/endpoints";

export function  getRecommendationList(params) {
  return http.request({
    url:RECOMMENDATION_URL,
    method:'get',
    params
  })
}
export function createRecommendation(postData){
  return http.request({
    url:RECOMMENDATION_URL,
    method:'post',
    data:postData
  })
}
export function updateRecommendation(id,postData){
  return http.request({
    url:RECOMMENDATION_URL+`/${id}`,
    method:'put',
    data:postData
  })
}
export function  fetchRecommendation(id) {
  return http.request({
    url:RECOMMENDATION_URL+`/${id}`,
    method:'get',
  })
}
export function deleteRecommendation(id){
  return http.request({
    url:RECOMMENDATION_URL+`/${id}`,
    method:'delete',
  })
}
export function activateRecommendation(id) {
  return http.request({
    url:RECOMMENDATION_URL+`/${id}/activate`,
    method:'put',
  })
}
export function deactivateRecommendation(id) {
  return http.request({
    url:RECOMMENDATION_URL+`/${id}/deactivate`,
    method:'put',
  })
}
export function getAllDomains() {
  return http.request({
    url: 'api/public/domains',
    method: 'get'
  })
}
